import React, { useState } from 'react'
import { Sticky } from 'react-sticky'
import { Link } from 'gatsby'

import * as Grid from '../../Grid'
import {
  HeaderCustom,
  Image,
  Container,
  LinkCustom,
  SubmenuButton,
  Submenu
} from './style'

import logoSkypostal from '../../../images/home/skypostal_logo.png'
import downArrow from '../../../assets/down-arrow.svg'

function Header() {
  const [showSubmenu, setshowSubmenu] = useState(false)
  const [showCustomerSubmenu, setShowCustomerSubmenu] = useState(false)
  return (
    <Sticky>
      {({ style }) => (
        <HeaderCustom style={style}>
          <Grid.Container>
            <Grid.Row>
              <Grid.Column md={12}>
                <Container>
                  <Link to="/">
                    <Image src={logoSkypostal} />
                  </Link>
                  <div
                    style={{
                      display: 'flex',
                      position: 'relative',
                      alignItems: 'center'
                    }}
                  >
                    <a
                      href="https://calendly.com/skypostal/integration-call"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        backgroundColor: '#007bff',
                        color: 'white',
                        textDecoration: 'none',
                        padding: '5px 8px',
                        borderRadius: '8px',
                        fontSize: 14
                      }}
                    >
                      Schedule a meeting
                    </a>
                    <SubmenuButton
                      type="button"
                      onClick={() => {
                        setShowCustomerSubmenu(!showCustomerSubmenu)
                        setshowSubmenu(false)
                      }}
                    >
                      <LinkCustom
                        as="span"
                        style={{ display: 'flex', alignItems: 'center' }}
                      >
                        CUSTOMER
                        <img src={downArrow} alt="down-arrow" />
                        {showCustomerSubmenu && (
                          <Submenu>
                            <li style={{ marginBottom: '16px' }}>
                              <LinkCustom to="/customer/api-box">
                                API-BOX
                              </LinkCustom>
                            </li>
                            <li style={{ marginBottom: '16px' }}>
                              <LinkCustom to="/customer/api-skypostal-current">
                                API-SKYPOSTAL
                                <small
                                  style={{ fontSize: '10px', color: 'blue' }}
                                >
                                  {' '}
                                  1.0
                                </small>
                              </LinkCustom>
                            </li>
                            <li style={{ marginBottom: '16px' }}>
                              <LinkCustom to="/customer/files">
                                FILES
                              </LinkCustom>
                            </li>
                            <li style={{ marginBottom: '16px' }}>
                              <LinkCustom to="/customer/api-skypostal">
                                API-SKYPOSTAL
                                <small
                                  style={{ fontSize: '10px', color: 'blue' }}
                                >
                                  {' '}
                                  2.0
                                </small>
                              </LinkCustom>
                            </li>
                          </Submenu>
                        )}
                      </LinkCustom>
                    </SubmenuButton>
                    <SubmenuButton
                      type="button"
                      onClick={() => {
                        setshowSubmenu(!showSubmenu)
                        setShowCustomerSubmenu(false)
                      }}
                    >
                      <LinkCustom
                        as="span"
                        style={{ display: 'flex', alignItems: 'center' }}
                      >
                        PROVIDER
                        <img src={downArrow} alt="down-arrow" />
                        {showSubmenu && (
                          <Submenu>
                            <li style={{ marginBottom: '16px' }}>
                              <LinkCustom to="/provider/api-skypostal">
                                API-SKYPOSTAL
                                <small
                                  style={{ fontSize: '10px', color: 'blue' }}
                                >
                                  {' '}
                                  2.0
                                </small>
                              </LinkCustom>
                            </li>
                            <li style={{ marginBottom: '16px' }}>
                              <LinkCustom to="/provider/files">
                                FILES
                              </LinkCustom>
                            </li>
                          </Submenu>
                        )}
                      </LinkCustom>
                    </SubmenuButton>
                    {/* <LinkCustom href="#login">Login</LinkCustom> */}
                  </div>
                </Container>
              </Grid.Column>
            </Grid.Row>
          </Grid.Container>
        </HeaderCustom>
      )}
    </Sticky>
  )
}

export default Header
